/**
 * A really simple utility function that returns true if the provided item is not null or undefined. Mainly
 * useful to get better typescript type inference for some Array.prototype.filter calls.
 * @param item The item to test for nullish-ness.
 */
export function notNullish<T>(item : T | null | undefined) : item is T {
    return item !== null && item !== undefined;
}



// WEBPACK FOOTER //
// ./lib/notNullish.ts